import types from './types';

export const editBillingFormRequest = (values) => ({
  type: types.EDIT_BILLING_FORM_REQUEST,
  values,
});
